<template>
    <div class="tw-flex tw-w-full tw-gap-2 tw-select-none tw-items-center">
        <div
            v-for="(step, index) in steps"
            :key="index"
            class="tw-relative tw-flex tw-flex-1 tw-gap-3 tw-items-center tw-justify-center"
        >
            <div
                class="tw-flex-1 tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center"
                :class="{ 'tw-text-black/[0.33]': stepIndex < index }"
            >
                <div
                    class="tw-flex tw-gap-1.5 tw-w-full tw-items-center tw-px-3 tw-h-8 tw-text-sm tw-rounded-md tw-text-white"
                    :class="{
                        'tw-bg-gray-100 !tw-text-gray-700': stepIndex < index,
                        'tw-bg-eventwise': stepIndex === index,
                        'tw-bg-eventwise/10 !tw-text-eventwise': stepIndex > index,
                    }"
                >
                    <span class="tw-font-medium">{{ index + 1 }}.</span>
                    <span>{{ step }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    steps: {
        type: Array as () => string[],
        required: true,
    },
});

const model = defineModel<string | null>({ default: null });

const stepIndex = computed(() => (model.value === null ? -1 : props.steps.indexOf(model.value)));

const advance = () => {
    const currentIndex = stepIndex.value;
    if (currentIndex < props.steps.length - 1) {
        model.value = props.steps[currentIndex + 1];
    }
};

const retreat = () => {
    const currentIndex = stepIndex.value;
    if (currentIndex > 0) {
        model.value = props.steps[currentIndex - 1];
    }
};

defineExpose({ advance, retreat });
</script>
